module.exports = __webpack_public_path__ + "static/media/Glide-180x180.e4d78022.png";